import { FunctionComponent } from 'react'
import { Campaign, ContentContractType } from '../../../gql/types'
import { Icon, IconType } from '../../Icon'
import { BriefTextRow } from '../BriefRow'
import { Divider } from '../../Divider'

interface ICampaignInfoProps {
  campaign: Campaign
  viewMode: 'brand' | 'creator'
}

export const CampaignInfoBrief: FunctionComponent<ICampaignInfoProps> = ({
  campaign,
  viewMode,
}) => {
  const hasInfo =
    campaign.visibility === 'private' ||
    campaign.brand.contractType === ContentContractType.fullAssignment

  if (!hasInfo) return null

  return (
    <>
      <div className='@container'>
        <div className='grid @xl:grid-cols-4 @xl:gap-6 grid-cols-1 gap-2'>
          <div>
            <h3 className='text-base font-semibold leading-6 text-gray-900'>
              Information
            </h3>
          </div>
          <div className='overflow-hidden bg-white shadow rounded-lg col-span-3'>
            <div className='border-t border-gray-200 px-4'>
              <dl className='@md:divide-y @md:divide-gray-200'>
                {/* Visibility */}
                {/* Private campaigns are not visible to creators, only through invitation */}
                {campaign.visibility === 'private' && viewMode === 'brand' && (
                  <BriefTextRow
                    title='Visibility'
                    value={
                      <div className='flex items-center text-sm'>
                        <Icon
                          type={IconType.lock}
                          className='mr-1 w-5 h-5 text-gray-600'
                          aria-hidden='true'
                        />
                        Private Campaign (Invitation-only creators)
                      </div>
                    }
                  />
                )}
                {campaign.brand.contractType ===
                  ContentContractType.fullAssignment && (
                  <BriefTextRow
                    title='Contract Type'
                    value={
                      <div className='flex items-center text-sm'>
                        <Icon
                          type={IconType.verified}
                          className='mr-1 w-5 h-5 text-gray-600'
                          aria-hidden='true'
                        />
                        Custom contract. Content ownership transfer.
                      </div>
                    }
                  />
                )}
              </dl>
            </div>
          </div>
        </div>
      </div>
      <Divider className='py-8' />
    </>
  )
}
